// ============================================================================
// pig.dailys.index — the pig daily hub, off App's boot array
// ============================================================================
// Two obligations, and they arrived from two different owners.
//
//   pig.dailys.list             the hub's own full-history page sequence. It
//                               was presenter-owned already — a `while (true)`
//                               loop in a mount effect — so only the cursor
//                               moved, not the page size, the deleted_at
//                               filter or the date DESC order.
//   pig.dailys.groupDirectory   the ppp-feeders-v1 app_store blob, which
//                               reached this surface as the `feederGroups`
//                               PigEntry prop carrying App's former-eager boot
//                               result. Removing that hand-off is what retires
//                               `pigdailys` from the frozen app_store consumer
//                               list in
//                               tests/fixtures/former-eager-dependencies.json.
//
// The directory resource is declared by BOTH daily surfaces because
// PigDailysRouter reads it above the index/record branch — the same place the
// prop used to land, and the same place it was forwarded to the record page
// from. A resource may only name surfaces the manifest declares migrated, so
// the record page had to move in the same change; see pig.dailys.detail.ts.
//
// Saved views are not an obligation here for the same reason they are not one
// on layer.dailys.index: useSavedViewsData owns that read for every surface
// that has a picker.
//
// WHY residualLegacy IS EMPTY WHILE TWO WRITES REMAIN.
//
// The hub still publishes into DailysRecentContext — `setPigDailys`, read off
// the provider rather than threaded as a prop, plus the pig branch of App's
// retired `refreshDailys` fan-out, which is `loadAllPigDailys` into that same
// setter and is owned here now. Both are WRITES into a projection this surface
// does not render: Home, Pigs Home, Sows and the pig batch hub read
// `pigDailys`, and this list reads its own rows. A setter is not a read, which
// is exactly why the provenance derivation scores it as non-consuming, and it
// is the same disposition cattle.dailys.index carries for the same context.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'pig.dailys.index',
  obligations: Object.freeze([
    Object.freeze({id: 'pig.dailys.list', owner: 'permanent'}),
    Object.freeze({id: 'pig.dailys.groupDirectory', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
